<svelte:options customElement={{
  tag: 'radio-field',
  shadow: 'none',
  props: {
    name: { reflect: true, type: 'String' },
    options: { reflect: true, type: 'String' },
    legend: { reflect: true, type: 'String' },
    error: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * radiobutton：ラジオボタン
   * パーツライブラリ準拠の mod-fieldset / mod-radio 構造
   */
  export let name = 'radio';
  export let options = '[]';
  export let legend = 'ラジオボタン選択の説明テキスト';
  export let error = '';

  let parsedOptions = [];
  let selected = '';

  $: {
    try {
      parsedOptions = typeof options === 'string' ? JSON.parse(options) : (Array.isArray(options) ? options : []);
    } catch (e) {
      parsedOptions = [];
    }
  }
</script>

<div class:__error={!!error}>
  <fieldset class="mod-fieldset">
    <legend class="mod-fieldset-legend">{legend}</legend>
    {#each parsedOptions as option, i}
      <label class="mod-radio" for="{name}_{i}">
        <input
          type="radio"
          {name}
          id="{name}_{i}"
          value={option.value || option}
          bind:group={selected}
          on:change
        />
        <span class="mod-radio-text">{option.label || option}</span>
      </label>
    {/each}
  </fieldset>
  {#if error}
    <p class="color_red mt10">{error}</p>
  {/if}
</div>
